import React from 'react'
import { BasketTypes } from 'types'
import { CrossIcon } from 'assets/icons'
import { ShopContext } from 'stores/ShopStore'

import './Product.scss'

interface Props {
    item: BasketTypes.Item,
    edit: boolean
}

export default class Product extends React.Component<Props> {

    render() {

        const { productGroupName, name, week, quantity } = this.props.item

        return (
            <tr className="product">
                <td className="article">
                    { this.props.edit ?
                        <ShopContext.Consumer>
                            { (value: any) =>
                                <button className="edit-icon" onClick={(e) => value.removeFromBasket(this.props.item)}>
                                    <CrossIcon/>
                                </button>
                            }
                        </ShopContext.Consumer> :
                        null
                    }
                    <small>{productGroupName}</small>
                    {name}
                </td>
                <td className="week">{week}</td>
                <td className="quantity">{quantity}</td>
            </tr>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Product/index.tsx